<template>
  <div class="pt-10">
    <div class="row">
      <div class="col-11 mt-5 pt-5 text-left">
        <h5 class="text-danger">
          <strong>BONO PROMOCIONAL</strong>
        </h5>
      </div>
      <div class="col-1 mt-5 pt-5 text-left">
        <button
          @click="openModal()"
          data-bs-toggle="modal"
          data-bs-target="#modalPromo"
          class="btn btn-danger btn-block"
        >
          <i class="fa fa-plus m-0 p-0" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <!-- Lista de bonos -->

    <div class="row mt-4">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped table-sm">
            <caption class="visually-hidden">Listado de Promociones</caption>
            <thead>
              <tr>
                <th scope="col" style="text-align: left">Fecha inicial</th>
                <th scope="col" style="text-align: left">Fecha final</th>
                <th scope="col" style="text-align: left">Código</th>
                <th scope="col" style="text-align: left">Puntos</th>
                <th scope="col" style="text-align: left">Repeticiones</th>
                <th scope="col" style="text-align: left">Estado</th>
                <th scope="col" style="text-align: left">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in items" :key="'d' + `item-${i}`">
                <td style="text-align: left">
                  {{ item.initial_date }}
                </td>
                <td style="text-align: left">
                  {{ item.final_date }}
                </td>
                <td style="text-align: left">
                  {{ item.code }}
                </td>
                <td style="text-align: left">
                  <h5>
                    <span class="badge badge-pill badge-danger">
                      {{ item.points }}
                    </span>
                  </h5>
                </td>
                <td style="text-align: left">
                  <h5>
                    <span class="badge badge-pill badge-success">
                      {{ item.repetitions_by_user }}
                    </span>
                  </h5>
                </td>
                <td style="text-align: left">
                  {{ item.status.name }}
                </td>
                <td style="text-align: left">
                  <div class="btn-group" role="group">
                    <button
                      data-toggle="tooltip"
                      data-placement="bottom"
                      class="btn btn-info mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                      title="Debes reactivar el bono promocional para poderlo editar"
                      @click="openModalEdit(item)"
                    >
                      <i class="fa fa-pencil m-0 p-0" aria-hidden="true"></i>
                    </button>
                  </div>
                  <template v-if="item.status_id == 1">
                    <div class="btn-group" role="group">
                      <button
                        data-toggle="tooltip"
                        data-placement="bottom"
                        class="btn btn-success mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                        title="Listar usuario"
                        @click="irUser(item)"
                      >
                        <i class="fa fa-users m-0 p-0" aria-hidden="true"></i>
                      </button>
                    </div>
                  </template>
                  <template>
                    <div class="btn-group" role="group">
                      <button
                        data-toggle="tooltip"
                        data-placement="bottom"
                        class="btn btn-danger mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                        title="Eliminar bono"
                        @click="deleteCode(item)"
                      >
                        <i class="fa fa-trash m-0 p-0" aria-hidden="true"></i>
                      </button>
                    </div>
                  </template>
                  <!-- <template v-if="item.status_id == 2">
                    <div class="btn-group" role="group">
                      <button
                        data-toggle="tooltip"
                        data-placement="bottom"
                        class="btn btn-warning mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                        title="Reactivar bono promocional"
                        @click="openReactivate(item)"
                      >
                        <i class="fa fa-files-o m-0 p-0" aria-hidden="true"></i>
                      </button>
                    </div>
                  </template> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-2  "
        style="text-align: initial;"
      >
        <label style="color:black;" class="text-p mt-2">
          Página {{ currentPage }} de {{ totalPages }}
          <strong class="text-danger"> | </strong> total: {{ totaItems }}
        </label>
      </div>
      <div class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-2 ">
        <div class="float-right">
          <v-pagination
            total-visible="2"
            v-model="currentPage"
            :page-count="totalPages"
            :classes="bootstrapPaginationClasses"
          ></v-pagination>
        </div>
      </div>
    </div>

    <!-- fin de la lista de bonos -->

    <!-- Modal Nueva bono -->
    <div
      class="modal fade"
      id="modalPromo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered border-danger modal-xl">
        <div class="modal-content modal-promotional">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong>NUEVO BONO PROMOCIONAL</strong></label
                ><br />
              </div>

              <!-- Estructura del formulario -->

              <div class="col-12 m-0 p-0">
                <div class="form-group">
                  <div class="row" style="text-align: left">
                    <div class="col-7  m-0 p-0">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Código *</strong>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.code }"
                              type="text"
                              v-model="form.code"
                              class="form-control"
                              placeholder="Escribe aquí el código"
                            />
                          </div>
                          <span
                            v-if="errors.code"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.code }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                            ><strong>Tipo de usuario *</strong>
                            <i
                              class="fa fa-info-circle text-info ml-1"
                              style="font-size: 20px;"
                              aria-hidden="true"
                              data-bs-toggle="tooltip"
                              data-bs-placement="bottom"
                              title="Tipo de usuario que podra redimir el código"
                            ></i>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.type_user }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="form.type_user"
                            >
                              <option value="null" disabled selected>Seleccione el tipo de usuario</option>
                              <option value="1">Motero</option>
                              <option value="2">Lubricador</option>
                              <option value="3">Motero y Lubricador</option>
                            </select>
                          </div>
                          <span
                            v-if="errors.type_user"
                            class="text-danger float-left small error-danger mb-2"
                          >{{ errors.type_user }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                            ><strong>Tipo de producto *</strong>
                            <i
                              class="fa fa-info-circle text-info ml-1"
                              style="font-size: 20px;"
                              aria-hidden="true"
                              data-bs-toggle="tooltip"
                              data-bs-placement="bottom"
                              title="Tipo de producto al que pertenece el código"
                            ></i>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.type_product }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="form.type_product"
                            >
                              <option value="null" disabled selected>Seleccione el tipo de producto</option>
                              <option value="1">Mineral</option>
                              <option value="2">Synthetic</option>
                              <option value="3">Full Synthetic</option>
                              <option value="4">Campaña general</option>
                            </select>
                          </div>
                          <span
                            v-if="errors.type_product"
                            class="text-danger float-left small error-danger mb-2"
                          >{{ errors.type_product }}</span
                          >
                        </div>
                        
                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Puntos *</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Puntos que obtendra el usuario por la redención del código promocional. Estos puntos son independientes de los puntos que se otorgan por los códigos de productos."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.points }"
                              type="number"
                              v-model="form.points"
                              class="form-control"
                              placeholder="Escribe aquí los puntos"
                            />
                          </div>
                          <span
                            v-if="errors.points"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.points }}</span
                          >
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Repeticiones *</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="La repeticiones son la veces que un usuario puede registrar el mismo código pormocional."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.repetitionsByUser }"
                              type="number"
                              v-model="form.repetitionsByUser"
                              class="form-control"
                              placeholder="Escribe aquí el precio del producto"
                            />
                          </div>
                          <span
                            v-if="errors.repetitionsByUser"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.repetitionsByUser }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Fecha inicial *</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Fecha incial del código promocional, el código se activará de forma automática."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.initialDate }"
                              type="date"
                              v-model="form.initialDate"
                              class="form-control"
                              placeholder="Escribe aquí la fecha inicial"
                            />
                          </div>
                          <span
                            v-if="errors.initialDate"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.initialDate }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Fecha final *</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Fecha final del código promocional, el código se inactivará de forma automática."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.finalDate }"
                              type="date"
                              v-model="form.finalDate"
                              class="form-control"
                              placeholder="Escribe aquí la fecha final"
                            />
                          </div>
                          <span
                            v-if="errors.finalDate"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.finalDate }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Medio</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Medio de distribución del código promocional"
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.medimum }"
                              type="text"
                              v-model="form.medium"
                              class="form-control"
                              placeholder="Escribe aquí el medio"
                            />
                          </div>
                          <span
                            v-if="errors.medimum"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.medimum }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Canal</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Canal de distribución del código promocional"
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.channel }"
                              type="text"
                              v-model="form.channel"
                              class="form-control"
                              placeholder="Escribe aquí el canal"
                            />
                          </div>
                          <span
                            v-if="errors.channel"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.channel }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-5 m-0 p-0">
                      <!-- <div class="col-12"> -->
                      <div class="form-group">
                        <label
                          for="state"
                          style="color: #616161; font-size: 14px"
                          ><strong>Nombre</strong>
                        </label>
                        <input
                          :class="{ 'is-danger': errors.name }"
                          type="text"
                          v-model="form.name"
                          class="form-control"
                          placeholder="Escribe aquí el nombre "
                        />
                      </div>
                      <span
                        v-if="errors.name"
                        class="text-danger float-left small error-danger mb-2"
                        >{{ errors.name }}</span
                      >
                      <!-- </div> -->
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                          ><strong>Descripción del bono *</strong>
                        </label>
                        <textarea
                          :class="{ 'is-danger': errors.description }"
                          rows="8"
                          type="text"
                          v-model="form.description"
                          class="form-control"
                          placeholder="Escribe aquí la descripción"
                        />
                      </div>
                      <span
                        v-if="errors.description"
                        class="text-danger float-left small error-danger mb-2"
                        >{{ errors.description }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="save()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.history">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Aceptar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de editar bonos -->
    <div
      class="modal fade"
      id="modalPromoEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered border-danger modal-xl">
        <div class="modal-content modal-promotional">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong>EDITAR BONO PROMOCIONAL</strong></label
                ><br />
              </div>
              <!-- Estructura del formulario -->
              <div class="col-12 m-0 p-0">
                <div class="form-group">
                  <div class="row" style="text-align: left">
                    <div class="col-7  m-0 p-0">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Código *</strong>
                            </label>
                            <input
                              disabled
                              :class="{ 'is-danger': errors.code }"
                              type="text"
                              v-model="codeEdit"
                              class="form-control"
                              placeholder="Escribe aquí el código"
                            />
                          </div>
                          <span
                            v-if="errors.code"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.code }}</span
                          >
                          <div class="col-12"></div>
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                            ><strong>Tipo de usuario *</strong>
                            <i
                              class="fa fa-info-circle text-info ml-1"
                              style="font-size: 20px;"
                              aria-hidden="true"
                              data-bs-toggle="tooltip"
                              data-bs-placement="bottom"
                              title="Tipo de usuario que podra redimir el código"
                            ></i>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.type_user }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="formEdit.type_user"
                            >
                              <option value="null" disabled selected>Seleccione el tipo de usuario</option>
                              <option value="1">Motero</option>
                              <option value="2">Lubricador</option>
                              <option value="3">Motero y Lubricador</option>
                            </select>
                          </div>
                          <span
                            v-if="errors.type_user"
                            class="text-danger float-left small error-danger mb-2"
                          >{{ errors.type_user }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                            ><strong>Tipo de producto *</strong>
                            <i
                              class="fa fa-info-circle text-info ml-1"
                              style="font-size: 20px;"
                              aria-hidden="true"
                              data-bs-toggle="tooltip"
                              data-bs-placement="bottom"
                              title="Tipo de producto al que pertenece el código"
                            ></i>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.type_product }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="formEdit.type_product"
                            >
                              <option value="null" disabled selected>Seleccione el tipo de producto</option>
                              <option value="1">Mineral</option>
                              <option value="2">Synthetic</option>
                              <option value="3">Full Synthetic</option>
                              <option value="4">Campaña general</option>
                            </select>
                          </div>
                          <span
                            v-if="errors.type_product"
                            class="text-danger float-left small error-danger mb-2"
                          >{{ errors.type_product }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Puntos</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Puntos que obtendra el usuario por la redención del código promocional. Estos puntos son independientes de los puntos que se otorgan por los códigos de productos."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.points }"
                              type="number"
                              v-model="formEdit.points"
                              class="form-control"
                              placeholder="Escribe aquí los puntos"
                            />
                          </div>
                          <span
                            v-if="errors.points"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.points }}</span
                          >
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Repeticiones *</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="La repeticiones son la veces que un usuario puede registrar el mismo código pormocional."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.repetitionsByUser }"
                              type="number"
                              v-model="formEdit.repetitionsByUser"
                              class="form-control"
                              placeholder="Escribe aquí el precio del producto"
                            />
                          </div>
                          <span
                            v-if="errors.repetitionsByUser"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.repetitionsByUser }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Fecha inicial *</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Fecha incial del código promocional, el código se activará de forma automática."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.initialDate }"
                              type="date"
                              v-model="formEdit.initialDate"
                              class="form-control"
                              placeholder="Escribe aquí la fecha inicial"
                            />
                          </div>
                          <span
                            v-if="errors.initialDate"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.initialDate }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Fecha final *</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Fecha final del código promocional, el código se inactivará de forma automática."
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.finalDate }"
                              type="date"
                              v-model="formEdit.finalDate"
                              class="form-control"
                              placeholder="Escribe aquí la fecha final"
                            />
                          </div>
                          <span
                            v-if="errors.finalDate"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.finalDate }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Medio</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Medio de distribución del código promocional"
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.medimum }"
                              type="text"
                              v-model="formEdit.medium"
                              class="form-control"
                              placeholder="Escribe aquí el medio"
                            />
                          </div>
                          <span
                            v-if="errors.medium"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.medimum }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Canal</strong>
                              <i
                                class="fa fa-info-circle text-info ml-1"
                                style="font-size: 20px;"
                                aria-hidden="true"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title="Canal de distribución del código promocional"
                              ></i>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.channel }"
                              type="text"
                              v-model="formEdit.channel"
                              class="form-control"
                              placeholder="Escribe aquí el canal"
                            />
                          </div>
                          <span
                            v-if="errors.channel"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.channel }}</span
                          >
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                            ><strong>Activar e inactivar código</strong>
                            <i
                              class="fa fa-info-circle text-info ml-1"
                              style="font-size: 20px;"
                              aria-hidden="true"
                              data-bs-toggle="tooltip"
                              data-bs-placement="bottom"
                              title="Activar e inactivar código"
                            ></i>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.status_id }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="formEdit.status_id"
                            >
                              <option value="null" disabled selected>Activar e inactivar código</option>
                              <option value="1">Activo</option>
                              <option value="2">Inactivo</option>
                            </select>
                          </div>
                          <span
                            v-if="errors.status_id"
                            class="text-danger float-left small error-danger mb-2"
                          >{{ errors.status_id }}</span
                          >
                        </div>

                      </div>
                    </div>
                    <div class="col-5 m-0 p-0">
                      <!-- <div class="col-12"> -->
                      <div class="form-group">
                        <label
                          for="state"
                          style="color: #616161; font-size: 14px"
                          ><strong>Nombre </strong>
                        </label>
                        <input
                          :class="{ 'is-danger': errors.name }"
                          type="text"
                          v-model="formEdit.name"
                          class="form-control"
                          placeholder="Escribe aquí el nombre "
                        />
                      </div>
                      <span
                        v-if="errors.name"
                        class="text-danger float-left small error-danger mb-2"
                        >{{ errors.name }}</span
                      >
                      <!-- </div> -->
                      <div class="form-group">
                        <label
                          class="ml-1"
                          for="state"
                          style="color: #616161; font-size: 14px"
                          ><strong>Descripción del bono *</strong>
                        </label>
                        <textarea
                          :class="{ 'is-danger': errors.description }"
                          rows="8"
                          type="text"
                          v-model="formEdit.description"
                          class="form-control"
                          placeholder="Escribe aquí la descripción"
                        />
                      </div>
                      <span
                        v-if="errors.description"
                        class="text-danger float-left small error-danger mb-2"
                        >{{ errors.description }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="updateSave()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.history">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Actualizar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal reactivación -->

    <div
      class="modal fade"
      id="modalPromoReactivate"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered border-danger">
        <div class="modal-content modal-promotional">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong>REACTIVACIÓN BONO PROMOCIONAL</strong></label
                ><br />
              </div>
              <!-- Estructura del formulario -->

              <div class="col-6" style="text-align: left">
                <div class="form-group">
                  <label
                    class="ml-1"
                    for="state"
                    style="color: #616161; font-size: 14px;"
                    ><strong>Fecha inicial *</strong>
                    <i
                      class="fa fa-info-circle text-info ml-1"
                      style="font-size: 20px;"
                      aria-hidden="true"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title="Fecha incial del código promocional, el código se activará de forma automática."
                    ></i>
                  </label>
                  <input
                    :class="{ 'is-danger': errors.initialDate }"
                    type="date"
                    v-model="formReactive.initialDate"
                    class="form-control"
                    placeholder="Escribe aquí la fecha inicial"
                  />
                </div>
                <span
                  v-if="errors.initialDate"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.initialDate }}</span
                >
              </div>

              <div class="col-6" style="text-align: left">
                <div class="form-group">
                  <label
                    class="ml-1"
                    for="state"
                    style="color: #616161; font-size: 14px"
                    ><strong>Fecha final</strong>
                    <i
                      class="fa fa-info-circle text-info ml-1"
                      style="font-size: 20px;"
                      aria-hidden="true"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title="Fecha final del código promocional, el código se inactivará de forma automática."
                    ></i>
                  </label>
                  <input
                    :class="{ 'is-danger': errors.finalDate }"
                    type="date"
                    v-model="formReactive.finalDate"
                    class="form-control"
                    placeholder="Escribe aquí la fecha final"
                  />
                </div>
                <span
                  v-if="errors.finalDate"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.finalDate }}</span
                >
              </div>

              <div class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="reactivate()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.history">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Reactivar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import vPagination from "vue-plain-pagination"
import axios from "axios";

export default {
  components: { vPagination },
  data() {
    return {
      items: [],
      paginate: ["items"],
      page: 1,
      totalPages: 1,
      totaItems: null,
      currentPage: 1,
      form: {
        initialDate: null,
        finalDate: null,
        code: "",
        description: "",
        points: "",
        repetitionsByUser: null,
        typeCode: 1,
        name: "",
        medium: "",
        channel: "",
        type_user: null,
        type_product: null,
      },
      errors: {
        initialDate: false,
        finalDate: false,
        code: false,
        description: false,
        points: false,
        repetitionsByUser: false,
        typeCode: false,
        name: false,
        medium: false,
        channel: false,
        type_user: false,
        type_product: false,
      },
      bootstrapPaginationClasses: {
        ul: "pagination",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
      },
      loading: {
        history: false,
      },
      formEdit: {
        initialDate: null,
        finalDate: null,
        description: "",
        points: "",
        repetitionsByUser: null,
        typeCode: 1,
        name: "",
        medium: "",
        channel: "",
        id: null,
        type_user: null,
        type_product: null,
        status_id: null,
      },
      currentFormE: null,
      formReactive: {
        id: null,
        initialDate: null,
        finalDate: null,
      },
      codeEdit: "",
    };
  },
  watch: {
    "form.code": function(n) {
      if (!n) {
        this.errors.code = "Este campo es requerido.";
      } else if (!this.validateCode(n)) {
        this.errors.code =
          "El código es inválido debe tener de 3 a 25 caracteres, sin caracteres especiales, ni espacios.";
      } else {
        this.errors.code = false;
      }
    },
    "form.type_user": function(n) {
      if (n) {
        this.errors.type_user = false;
      } else {
        this.errors.type_user = "Este campo es requerido.";
      }
    },
    "form.type_product": function(n) {
      if (n) {
        this.errors.type_product = false;
      } else {
        this.errors.type_product = "Este campo es requerido.";
      }
    },
    "form.repetitionsByUser": function(n) {
      if (n) {
        this.errors.repetitionsByUser = false;
      } else {
        this.errors.repetitionsByUser = "Este campo es requerido.";
      }
    },
    "form.initialDate": function(n) {
      if (n) {
        this.errors.initialDate = false;
      } else {
        this.errors.initialDate = "Este campo es requerido.";
      }
    },
    "form.finalDate": function(n) {
      if (n) {
        this.errors.finalDate = false;
      } else {
        this.errors.finalDate = "Este campo es requerido.";
      }
    },
    "form.description": function(n) {
      if (n) {
        this.errors.description = false;
      } else {
        this.errors.description = "Este campo es requerido.";
      }
    },
    // Edición
    "formEdit.type_user": function(n) {
      if (n) {
        this.errors.type_user = false;
      } else {
        this.errors.type_user = "Este campo es requerido.";
      }
    },
    "formEdit.type_product": function(n) {
      if (n) {
        this.errors.type_product = false;
      } else {
        this.errors.type_product = "Este campo es requerido.";
      }
    },
    "formEdit.repetitionsByUser": function(n) {
      if (!n) {
        this.errors.repetitionsByUser = "Este campo es requerido.";
      } else if (n < 0) {
        this.errors.repetitionsByUser =
          "El número de repeticiones no puede ser negativo.";
      } else {
        this.errors.repetitionsByUser = false;
      }
    },
    "formEdit.initialDate": function(n) {
      if (n) {
        this.errors.initialDate = false;
      } else {
        this.errors.initialDate = "Este campo es requerido.";
      }
    },
    "formEdit.finalDate": function(n) {
      if (n) {
        this.errors.finalDate = false;
      } else {
        this.errors.finalDate = "Este campo es requerido.";
      }
    },
    "formEdit.description": function(n) {
      if (n) {
        this.errors.description = false;
      } else {
        this.errors.description = "Este campo es requerido.";
      }
    },
  },
  methods: {
    clearForm() {
      this.form = {
        initialDate: null,
        finalDate: null,
        code: "",
        description: "",
        points: "",
        repetitionsByUser: null,
        typeCode: 1,
        name: "",
        medium: "",
        channel: "",
      };
    },
    validateCode(code) {
      var re = /^[a-zA-Z0-9]{3,25}$/;
      return re.test(code);
    },
    reactivate() {
      this.loading.history = true;
      axios
        .post("admin/promotional/code/reactivate", this.formReactive)
        .then((res) => {
          this.loading.history = false;
          if (res.data.cod == 0) {
            $("#modalPromoReactivate").modal("hide");
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.getList();
          }
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    openReactivate(data) {
      this.formReactive.id = data.id;
      $("#modalPromoReactivate").modal("show");
    },
    irUser(data) {
      this.$router.push({ name: "listPromoUsers", params: { id: data.id } });
    },
    deleteCode(item){
      let app = this;
      axios
      .delete('admin/promotional/code/delete/' + item.id)
      .then((res) => {
        if (res.data.cod == 0) {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "success",
            title: "Muy bien",
            text: res.data.message,
          });
          this.getList();
        }
      })
      .catch((error) => {
        app.loading.history = false;
        app.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
    updateSave(){
      this.loading.history = true;
      // var data = {};
      // if (this.formEdit.name != this.currentFormE.name) {
      //   data.name = this.formEdit.name;
      // }
      // if (this.formEdit.initialDate != this.currentFormE.initial_date) {
      //   data.initialDate = this.formEdit.initialDate;
      // }
      // if (this.formEdit.finalDate != this.currentFormE.final_date) {
      //   data.finalDate = this.formEdit.finalDate;
      // }
      // if (this.formEdit.description != this.currentFormE.description) {
      //   data.description = this.formEdit.description;
      // }
      // if (this.formEdit.channel != this.currentFormE.channel) {
      //   data.channel = this.formEdit.channel;
      // }
      // if (this.formEdit.medium != this.currentFormE.medium) {
      //   data.medium = this.formEdit.medium;
      // }
      // if (
      //   this.formEdit.repetitionsByUser != this.currentFormE.repetitions_by_user
      // ) {
      //   data.repetitionsByUser = this.formEdit.repetitionsByUser;
      // }
      // if (this.formEdit.points != this.currentFormE.points) {
      //   data.points = this.formEdit.points;
      // }

      // data.id = this.currentFormE.id;
      console.log('this.formEdit: ', JSON.stringify(this.formEdit));
      axios
        .post("admin/promotional/code/edit", this.formEdit)
        .then((res) => {
          this.loading.history = false;
          if (res.data.cod == 0) {
            $("#modalPromoEdit").modal("hide");
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.getList();
          }
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          }).then(() => {
            $("#modalPromoEdit").modal("hide");
          });
        });
    },
    openModalEdit(data) {
      this.currentFormE = data;
      this.formEdit.name = data.name;
      this.formEdit.initialDate = data.initial_date;
      this.formEdit.finalDate = data.final_date;
      this.codeEdit = data.code;
      this.formEdit.description = data.description;
      this.formEdit.points = data.points;
      this.formEdit.repetitionsByUser = data.repetitions_by_user;
      this.formEdit.typeCode = data.type_code;
      this.formEdit.medium = data.medium;
      this.formEdit.channel = data.channel;
      this.formEdit.type_user = data.type_user;
      this.formEdit.type_product = data.type_product;
      this.formEdit.status_id = data.status_id;
      this.formEdit.id = data.id;
      $("#modalPromoEdit").modal("show");
    },
    openModal() {
      $("#modalPromo").modal("show");
    },
    save(){
      this.loading.history = true;
      axios
        .post("admin/promotional/code/create", this.form)
        .then((res) => {
          this.loading.history = false;
          if (res.data.cod == 0) {
            $("#modalPromo").modal("hide");
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.clearForm();
            this.getList();
          }
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    getList() {
      this.loading.history = true;
      axios
        .get("admin/promotional/code/list")
        .then((res) => {
          this.loading.history = false;
          if (res.data.cod == 0) {
            this.items = res.data.data;
            console.log();
          }
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style>
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.page-link {
  border-radius: 100px;
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #dc3545;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  color: #000;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
